export const accountPages = ['routes/_menu.account'];

export const authPages = [
  'routes/_menu.login._index',
  'routes/_menu.login.email',
  'routes/_menu.forgot-password',
  'routes/_menu.reset-password',
  'routes/_menu.signup',
];

export const customRowPages = [
  'routes/_menu.($storeSlug).rows.$customRowId.$slug',
  'routes/_menu.store.$storeId.rows.$customRowId.$slug',
];

export const featuredPages = [
  'routes/_menu.($storeSlug).featured._index',
  'routes/_menu.store.$storeId.featured._index',
];

export const categoryPages = [
  'routes/_menu.($storeSlug).edible._index',
  'routes/_menu.($storeSlug).extract._index',
  'routes/_menu.($storeSlug).flower._index',
  'routes/_menu.($storeSlug).gear._index',
  'routes/_menu.($storeSlug).grow._index',
  'routes/_menu.($storeSlug).merch._index',
  'routes/_menu.($storeSlug).pre-roll._index',
  'routes/_menu.($storeSlug).tincture._index',
  'routes/_menu.($storeSlug).topical._index',
  'routes/_menu.($storeSlug).vape._index',
  'routes/_menu.($storeSlug).shop-all._index',

  'routes/_menu.store.$storeId.edible._index',
  'routes/_menu.store.$storeId.extract._index',
  'routes/_menu.store.$storeId.flower._index',
  'routes/_menu.store.$storeId.gear._index',
  'routes/_menu.store.$storeId.grow._index',
  'routes/_menu.store.$storeId.merch._index',
  'routes/_menu.store.$storeId.pre-roll._index',
  'routes/_menu.store.$storeId.tincture._index',
  'routes/_menu.store.$storeId.topical._index',
  'routes/_menu.store.$storeId.vape._index',
  'routes/_menu.store.$storeId.shop-all._index',
];

export const plpPages = [
  ...featuredPages,
  ...categoryPages,
  ...customRowPages,

  'routes/_menu.search',

  'routes/_menu.($storeSlug).deals._index',
  'routes/_menu.($storeSlug).deals.$dealId.$slug',
  'routes/_menu.($storeSlug).jane-gold._index',
  'routes/_menu.($storeSlug).jane-gold.$specialId.$slug',

  'routes/_menu.store.$storeId.deals._index',
  'routes/_menu.store.$storeId.deals.$dealId.$slug',
  'routes/_menu.store.$storeId.jane-gold._index',
  'routes/_menu.store.$storeId.jane-gold.$specialId.$slug',
];

export const pdpPages = ['routes/_menu.products.$productId.$slug'];
